import React, {forwardRef, useEffect, useState} from 'react';

const TextInput = forwardRef(({
                                  label,
                                  name,
                                  value,
                                  onChange,
                                  placeholder,
                                  className = '',
                                  onKeyDown,
                                  onEnter,
                                  required = false,
                                  disabled = false
                              }, ref) => {

    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const handleOneKeyDown = (e) => {
        if (onKeyDown) {
            onKeyDown(e);
        }
        if (e.key === 'Enter') {
            const newValue = onEnter?.(inputValue);
            if (newValue !== undefined) {
                setInputValue(newValue);
            }
        }
    }

    const handleValueChange = (inputValue) => {
        setInputValue(inputValue);
        onChange?.(inputValue);
    }

    return (
        <div className="FormInput">
            <label className={`${required ? 'required' : ''}`} htmlFor={name}>{label}</label>
            <input
                required={required}
                disabled={disabled}
                onKeyDown={handleOneKeyDown}
                ref={ref}
                id={name}
                name={name}
                type="text"
                value={inputValue || ''}
                onChange={e => handleValueChange(e.target.value)}
                placeholder={placeholder}
                className={`appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm ${className}`}
            />
        </div>
    );
});

export default TextInput;
